/**
 * j file list
 * List uploaded files
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { SettingsService } from '../../services/settings.service.js';
import { FileService } from '../../services/file.service.js';
import { getContentTypeLabel } from '../../utils/file-upload-rules.js';

export function createFileListCommand(): Command {
    return new Command('list')
        .description('List uploaded files')
        .option('--project-id <id>', 'Filter by project')
        .option('--personal', 'Show personal files only')
        .option('--limit <n>', 'Number of results per page', '20')
        .option('-p, --page <n>', 'Page number', '1')
        .option('-j, --json', 'JSON output')
        .action(async (opts) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                // Determine filter
                let scope: string | undefined;
                let projectId: string | undefined;

                if (opts.personal) {
                    scope = 'personal';
                } else if (opts.projectId) {
                    projectId = opts.projectId;
                } else {
                    // Auto-detect
                    const settings = new SettingsService();
                    const detectedProjectId = settings.getProjectId();
                    if (detectedProjectId) {
                        projectId = detectedProjectId;
                    } else if (!opts.json) {
                        console.log(chalk.dim('Không detect được project → hiện personal files'));
                    }
                }

                const limit = parseInt(opts.limit);
                const page = parseInt(opts.page);
                const offset = (page - 1) * limit;

                const service = new FileService();
                let result;
                try {
                    result = await service.list(config, {
                        scope,
                        projectId,
                        limit,
                        offset,
                    });
                } catch (listError) {
                    // Auto-detect project failed (not a member) → fallback to personal
                    const isAutoDetect = !!projectId && !opts.projectId && !opts.personal;
                    const isAccessDenied = listError instanceof Error && listError.message.includes('not a project member');
                    if (isAutoDetect && isAccessDenied) {
                        if (!opts.json) {
                            console.log(chalk.dim(`Project "${projectId}" chưa đăng ký → hiện personal files`));
                        }
                        result = await service.list(config, {
                            scope: 'personal',
                            limit,
                            offset,
                        });
                    } else {
                        throw listError;
                    }
                }

                if (opts.json) {
                    console.log(JSON.stringify(result, null, 2));
                    return;
                }

                if (result.files.length === 0) {
                    console.log(chalk.dim('Chưa có file nào.'));
                    return;
                }

                const totalPages = Math.ceil(result.total / limit);

                console.log();
                console.log(chalk.bold(`Files (${result.total} total)`) + (totalPages > 1 ? chalk.dim(` — page ${page}/${totalPages}`) : ''));
                console.log();

                for (const file of result.files) {
                    const sizeKB = (file.contentSize / 1024).toFixed(1);
                    const date = new Date(file.createdAt).toLocaleDateString('vi-VN');
                    const typeLabel = getContentTypeLabel(file.contentType).toUpperCase();
                    console.log(
                        `  ${chalk.cyan(`#${file.id}`)} ${chalk.bold(file.filename)}` +
                        chalk.dim(` [${typeLabel}] (${sizeKB}KB, ${date})`)
                    );
                    console.log(`     ${chalk.dim(file.url)}`);
                    if (file.filePath) {
                        console.log(`     ${chalk.dim(`Path: ${file.filePath}`)}`);
                    }
                }

                if (page < totalPages) {
                    console.log(chalk.dim(`  Use "j file list -p ${page + 1}" to see next page`));
                }
                console.log();

            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
